module.exports = __webpack_public_path__ + "img/product-ketang-jm-04.5272675c.png";